import { prefix } from '../../utils/prefix';

const Url = {
  getInfo: `${prefix}/info/healthInfo/get`,
  save: `${prefix}/info/healthInfo/save`,
};

export default Url;
